import {
  getProductItemsTotalCount,
  updateItemCount,
} from "../../../js/pages/cart.js";
import {
  CART_ITEM_SELECTOR,
  CART_SECTION_SELECTOR,
  QUANTITY_AMOUNT_SELECTOR,
  QUANTITY_INVENTORY_AMOUNT_SELECTOR
} from "./selectors.js";
import ShopifyFrontendHelper from "../../../node_modules/shopify-api-js/lib/ShopifyFrontendHelper.js";
import { gtmChangeCart } from '../../../js/helpers/gtm/gtmChangeCart';

export const setLoading = (isLoading, optionalIdentifier) => {
  const timerIdentifier = optionalIdentifier ? `apiCallWrapper-${optionalIdentifier}` : `apiCallWrapper`;
  if(isLoading) {
    console.time(timerIdentifier);
  }else {
    console.timeEnd(timerIdentifier);
  }
  const event = new CustomEvent(`cart:loading:${isLoading}`, {
    detail: {
      isLoading,
    },
  });

  document.querySelector(CART_SECTION_SELECTOR).dispatchEvent(event);
};

export class ShopifyFrontendHelperAugmented extends ShopifyFrontendHelper {


  /**
   * @param variantOrVariants a number or a string representing a variant - or a list
   * of variatns
   */
  async removeAllFromCart(variantOrVariants)  {
        let updates = {};
        if(Array.isArray(variantOrVariants)) {
          for(const variantId of variantOrVariants) {
            updates[variantId] = 0;
          }
        } else {
          updates[variantOrVariants] = 0;
        }
        const body = JSON.stringify({ updates: updates });
        const config = this.fetchConfig();
        return await fetch(
            this.routes + 'cart/update.js',
            { ...config, body })
            .then((response) => { return response.json(); })
            .then((state) => { return state; })
            .catch((e) => {
                return e;
            });
    }
      async addToCart(items) {
        const body = JSON.stringify({ items: items });
        const config = this.fetchConfig();
        try {
          const fetchResult = await fetch(this.routes + 'cart/add.js', Object.assign(Object.assign({}, config), { body }))
          const json = fetchResult.json();
          return json;
        }catch(e) {
          console.error(e)
          throw e;
        }
    }

}

export function _updateQuantityIncreaseSelectorState(lineItemElement, increaseQuantityElement, setAvailable = true)  {
    const currentLIKey = lineItemElement.dataset.key;
    const currentLIId = lineItemElement.dataset.id;
    const currentQuantity = lineItemElement.querySelector(QUANTITY_AMOUNT_SELECTOR).dataset.value;
    const currentInventoryPolicy = lineItemElement.getAttribute("data-inventory-policy");
    
    const quantityInventoryHiddenInput = increaseQuantityElement.parentNode.querySelector(
      QUANTITY_INVENTORY_AMOUNT_SELECTOR
    );


  //because we might have other LIs with the same variant - we have to check the others
     const otherLineItemsWithSameVariant =
        Array( ... _selectAllRenderedCartItemElements()).
          filter(element => element.dataset.key !== currentLIKey && element.dataset.id == currentLIId);
          
    const otherItemsQuantities = otherLineItemsWithSameVariant.
        //so stupid we're not using Vue..
      map(el => Number(el.querySelector(QUANTITY_AMOUNT_SELECTOR).dataset.value)).
        reduce((prev, current) => prev + current, 0);
        
    const totalQuantityOfThisVariant = Number(currentQuantity) + Number(otherItemsQuantities);
    
    debugger;
    
    if (totalQuantityOfThisVariant >= Number(quantityInventoryHiddenInput.value) && currentInventoryPolicy === "deny") {
      increaseQuantityElement.disabled = true;
      return;
    }
    increaseQuantityElement.disabled = setAvailable === false;
    
  }

export function _selectAllRenderedCartItemElements() {
  return document.querySelectorAll(CART_ITEM_SELECTOR);
}
export function generateUniqueId() {
    return Date.now().toString(36) + Math.random().toString(36).substring(2);
}

export const apiCallWrapper = async (apiCall, additionalData, silentlyIgnoreErrors) => {
  setLoading(true);
  try {
    const result = await apiCall;

    const updateEvent = new CustomEvent("cart:update", {
      detail: {
        cart,
        additionalData,
      },
    });
    
    if(result === undefined || result === null) {
      console.warn(`apiCallWrapper erroneously called :( returning prematurely and assuming all ok`)
      document.querySelector(CART_SECTION_SELECTOR).dispatchEvent(updateEvent);
      return result;
    }

    if (result?.status === "bad_request" || (isNaN(result.status) === false && Math.trunc(result.status / 100) !== 2)) {
      const errorMessage = result.message ? `${result.message} - ${result.description}` : result.description
      throw new Error(errorMessage, result);
    }
    
    if (result instanceof Error) {
      //shouldn't happen, but does - need to change lib
      //https://shopsys.atlassian.net/browse/APP-103?focusedCommentId=149552
      throw result;
    }

    let cart = result;
    if (!cart?.items || !cart?.total_price) {
      cart = null;
    }

    document.querySelector(CART_SECTION_SELECTOR).dispatchEvent(updateEvent);
    if (result !== undefined) {
      window.sections.header_section.refresh()
    }

    if(additionalData) {
      gtmChangeCart(additionalData.itemsId, additionalData.quantityValue, additionalData.listName, additionalData.isAddToCart);
    }
    return result;
  } catch (e) {
    if(silentlyIgnoreErrors !== true) {
      document.querySelector(CART_SECTION_SELECTOR).dispatchEvent(new CustomEvent("cart:update-error", {
        detail: {
          e,
          additionalData,
          apiCall
        }, }));
    }
    console.error(e);
    throw e;
  } finally {
    setLoading(false);
  }
};

export const getCart = async (returnItems = false) => {
  try {
    const cart = await fetch("/cart.js");
    const cartData = await cart.json();
    return returnItems ? cartData.items : cartData;
  } catch (e) {
    throw e;
  }
};

//TODO refactor - see ShopifyFrontendHelperAugmented above
export const updateCart = (updates) => {
  return fetch(window.Shopify.routes.root + "cart/update.js", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ updates }),
  })
    .then((response) => {
      return response.json();
    })
    .catch((error) => {
      console.error("Error:", error);
      throw error;
    });
};

export const getCoupon = async (coupon) => {
  return fetch(window.Shopify.routes.root + `discount/${coupon}`).catch(
    (error) => {
      console.error("Error:", error);
      throw error;
    }
  );
};